<template>
  <div style="position: relative">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="套餐记录" name="tc">
        <sign-statistics></sign-statistics>
      </el-tab-pane>
      <!-- 套餐记录 end -->
      <el-tab-pane label="积分记录" name="jf" style="background-color: #ffffff">
        <score></score>
      </el-tab-pane>
      <!-- 积分记录 end -->
      <el-tab-pane
        v-if="isVisi == 1 && isShow"
        label="APPKEY查询"
        name="appkey"
        style="background-color: #ffffff"
      >
        <app-key></app-key>
      </el-tab-pane>
      <!-- APPKEY查询 end -->
      <!-- 转赠记录  -->
      <el-tab-pane label="转赠记录" name="transfer" style="background-color: #ffffff" v-if="showFlag && (currentAuthUser.corpUserId || authUser.userType === 1)">
        <transferRecord v-if="activeName === 'transfer'"></transferRecord>
      </el-tab-pane>
    </el-tabs>
    <div class="recharge-sty">
      <span
        class="first_red_btn"
        v-if="!isInDingTalk && accountInfoVO.rechargeButton === 1 && isShow"
        @click="toByPoint"
        >去充值
      </span>
    </div>
  </div>
</template>
<script>
import Score from "../tpl/score.vue";
import signStatistics from "../tpl/signStatistics.vue";
import appKey from "./components/APPKey.vue";
import { ApiMethods } from "../../assets/js/http-serve/http-methods";
import { mapGetters } from "vuex";
import { configUrl } from "../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import { isCorp } from "@/assets/js/utils/others";
import transferRecord from "./components/transferRecord";
export default {
  components: { signStatistics, Score, appKey, transferRecord },
  data () {
    return {
      isInDingTalk,
      activeName: "tc",
      isVisi: 0
    };
  },
  mounted () {
    this.$nextTick(() => {
      let a = this.$route.query.type;
      this.activeName = a ? a : "tc";
    })
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event);
    },
    toByPoint () {
      if (this.allAuthUser.accountInfoVO.rechargeButton === 1) {
        let url = configUrl().accountWeb + "/asset/pointChargePage";
        if (isInDingTalk) {
          url = url + "?dingH5=1";
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        } else {
          window.open(url, "_blank");
        }
      } else {
        this.$alert("请联系供应商充值积分", { confirmButtonText: "确定" });
      }
    }
  },
  created () {
    // corpQuery 1:成员查询企业。其他不传这个参数。
    ApiMethods.accountCenter.appkeyDisplay(isCorp() ? { corpQuery: 1 } : {}).then(res => {
      if (!res.success) return this.$message.error(res.description);
      this.isVisi = res.data;
    });
  },
  computed: {
    ...mapGetters(["authUser", "allAuthUser", "currentAuthUser"]),
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    isShow () {
      // 主账号展示，加入的企业不显示
      const binds = this.$store.getters.allAuthUser.bindCorpUsers;
      const bindCorpIds = binds.map(bind => {
        return bind.corpUserId
      })
      const isCorp = bindCorpIds.includes(this.$store.getters.currentAuthUser.corpUserId);
      return !isCorp
      // return this.$store.getters.allAuthUser.manCorpUser.userType === 1 && this.$store.getters.allAuthUser.manCorpUser.corpUserId === this.$store.getters.currentAuthUser.corpUserId
    },
    showFlag(){
      const {packageRegiftFlag} = this.currentAuthUser
      return (packageRegiftFlag && packageRegiftFlag ==1) ? true : false
    },
  }
};
</script>
<style lang="less" scoped>
.recharge-sty {
  padding-right: 20px;
  position: absolute;
  top: 10px;
  right: 6px;
}
.first_red_btn {
  padding: 2px 10px;
  margin-right: 10px;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 5px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  background-color: rgba(236, 28, 28, 1);
  &:hover {
    background-color: #f26060;
    color: #ffffff;
  }
}
/deep/ .el-tabs__item.is-active {
  color: #ec1c1c;
}

/deep/ .el-tabs__active-bar {
  background-color: #ec1c1c;
}

/deep/ .el-tabs__item:hover {
  color: #ec1c1c;
}

/deep/ .el-tabs__nav {
  transform: translateX(20px) !important;
}
</style>



// WEBPACK FOOTER //
// pages/signSettings/costStatistics.vue